<div class="dialog-wrapper">
    <header class="dialog-header">
      <h3 class="header-heading">{{ 'pages.userFamily.edit.heading' | translate }}</h3>
      <button mat-icon-button class="close-button" aria-label="Close" (click)="closeDialog()">
        <span class="icon-close"></span>
      </button>
    </header>
  
    <div class="dialog-content">
  
  
      <div class="family-member">
        <img class="user-avatar" *ngIf="!data.link.userId.picture" src="https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png" alt="demo-avatar">
        <img class="user-avatar" *ngIf="data.link.userId.picture" [src]="data.link.userId.picture" alt="demo-avatar">
        <div class="row">
            <div class="col">
              <div class="row name">
                <div>{{ data.link.userId.firstName }} {{ data.link.userId.lastName }}</div>
              </div>
              <div *ngIf="data.link.link" class="row link">
                <div>
                    <span>{{ linkLabel }}</span>
                </div>
              </div>
            </div>
        </div>
      </div>
  
      <form [formGroup]="editFamilyMemberLinkTypeForm">
        <app-user-family-select 
          controlName="link"
          [label]="'pages.userFamily.link.label' | translate"
          [placeholder]="'pages.userFamily.link.placeholder' | translate"
          [form]="editFamilyMemberLinkTypeForm"
          [options]="familyLinks"
          (selectChange)="handleSelect($event)"
        ></app-user-family-select>
      </form>
    
    </div>
  
    <footer class="dialog-footer">
      <div class="inline-button-wrap">
        <button 
          class="bciti-inline-button"
          (click)="closeDialog()"
        >{{ 'pages.userFamily.button.cancel' | translate }}</button>
      </div>
      
      <button 
        class="bciti-button"
        [ngClass]="!editFamilyMemberLinkTypeForm?.valid || processingSubmit ? 'bciti-button--disabled' : 'bciti-button--blue'"
        [disabled]="!editFamilyMemberLinkTypeForm?.valid || processingSubmit"
        (click)="submit()"
      >
        <span *ngIf="!processingSubmit">{{ 'pages.userFamily.button.submit' | translate }}</span>
        <mat-spinner diameter="20" *ngIf="processingSubmit"></mat-spinner>
      </button>
    </footer>
  </div>
  